import { render } from "./uiContextMenuItem.vue?vue&type=template&id=0c22f392"
import script from "./uiContextMenuItem.vue?vue&type=script&lang=js"
export * from "./uiContextMenuItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__